//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('../../util/ClassFunc')
const Common = require('./Common')
const Referee = require('../to/Referee')

const referee = new Referee
/**
 * The Referee class acts as the view object for the referee.
 */
const tbs_model_vo_Referee = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Referee.prototype = {
    /* The view object name */
    name: 'referee',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmRefereeList',
            basePath: 'data.list',
            query: {
                accountId: 'organizationId',
                clientType: '(h5)',
            },
            rule: {
                id: 'id',
                organizationId: 'organizationId',
                name: 'name',
                firstLetter: '$nameInitials',
                avatarUrl: 'avatar',
                description: '$refereeSportType,refereeLevel',
                isInvited: '@userId',
                sportType: '$refereeSportType',
                status: '$status',
                roleLabel: '$id'
            }
        },
        prefetch: {
            method: 'get',
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccount2',
            query: {
                id: 'organizationId',
            },
            basePath: 'data.account',
            rule: {
                sportTypeOptions: '$sportValueArray',
                organizationId: 'id',
                gender: '(1)',
                enabled: '@id'
            }
        },
        fetch: [
            {
                method: 'get',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'GetCrmAccount2',
                query: {
                    id: 'organizationId',
                },
                basePath: 'data.account',
                rule: {
                    sportTypeOptions: '$sportValueArray',
                }
            },
            {
                method: 'get',
                baseUrl: process.env.VUE_APP_BANMA_API,
                apiPrefix: '/bmmatch/',
                service: 'AdminGetCrmReferee',
                query: {
                    id: 'id',
                },
                basePath: 'data.referee',
                rule: {
                    id: 'id',
                    organizationId: 'accountId',
                    name: 'name',
                    avatarUrl: 'avatar',
                    gender: '~gender',
                    phone: 'mobile',
                    sportType: '$refereeSportType',
                    grade: '$refereeSportType,refereeLevel',
                    gradeLabel: 'refereeLevel',
                    gradeIndex: '$refereeSportType,refereeLevel',
                    credentialNum: 'refereeCardNo',
                    enabled: '$status',
                    isInvited: '@userId',
                }
            },
        ],
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmReferee',
            basePath: 'data.referee',
            rule: {
                id: 'id',
                organizationId: 'accountId',
                name: 'name',
                firstLetter: '$nameInitials',
                avatarUrl: 'avatar',
                genderLabel: '$gender',
                phone: 'mobile',
                sportTypeLabel: 'refereeSportType',
                gradeLabel: 'refereeLevel',
                credentialNum: 'refereeCardNo',
                enabledLabel: '$status',
                isInvited: '@userId',
                roleLabel: '$id'
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateCrmReferee',
            basePath: '',
            rule: {
                accountId: 'organizationId',
                name: 'name',
                avatar: '$avatar,avatarUrl',
                gender: '#gender',
                mobile: 'phone',
                refereeSportType: '$sportType',
                refereeLevel: '$grade',
                refereeCardNo: 'credentialNum',
                status: '$enabled'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateCrmReferee',
            basePath: '',
            rule: {
                id: 'id',
                accountId: 'organizationId',
                name: 'name',
                avatar: '$avatar,avatarUrl',
                gender: '#gender',
                mobile: 'phone',
                refereeSportType: '$sportType',
                refereeLevel: '$grade',
                refereeCardNo: 'credentialNum',
                status: '$enabled'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateCrmRefereeStatus',
            basePath: '',
            rule: {
                id: 'id',
                accountId: 'organizationId',
                status: '(-2)',
            }
        },
        send: {
            method: 'post',
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateCrmAccountRefereeInvitationTicket',
            query: {
                refereeId: 'refereeId',
                accountId: 'organizationId'
            },
            basePath: '',
            rule: {
                refereeId: 'refereeId',
                accountId: 'organizationId'
            }
        },
        invite: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccountRefereeInvitationInfo',
            method: 'get',
            basePath: 'data',
            query: {
                ticket: 'ticket',
            },
            rule: {
                id: 'refereeId',
                name: 'refereeName',
                roleLabel: '$id',
                organizationId: 'accountId',
                organizationName: 'accountName',
                organizationLogoUrl: 'accountLogo',
            }
        },
        accept: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AcceptCrmAccountRefereeInvitation2',
            basePath: '',
            rule: {
                ticket: 'ticket',
            }
        }
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderEnabledLabel: function(status) {
        if (status == 0) {
            return referee.localeProp('status-option-1')
        }
        else {
            return referee.localeProp('status-option-2')
        }
    },
    renderGenderLabel: function(gender) {
        return referee.localeProp('gender-option-' + gender)
    },
    renderSportType: function(refereeSportType) {
        for (let i = 1; i < 12; i++) {
            let label = referee.localeProp('sport-type-' + i)
            if (label == refereeSportType) {
                return i.toString()
            }
        }
    },
    renderDescription: function(refereeSportType, refereeLevel) {
        if (refereeSportType && refereeLevel) {
            return refereeSportType + '/' + refereeLevel
        }
        else { 
            return ''
        }
    },
    formatRefereeSportType: function(sportType) {
        return referee.localeProp('sport-type-' + sportType)
    },
    renderEnabled: function(status) {
        return (status === 0)
    },
    renderStatus: function(status) {
        if (status == 0) {
            return '1'
        }
        else {
            return '2'
        }
    },
    formatStatus: function(enabled) {
        if (enabled) {
            return 0
        }
        else {
            return -1
        }
    },
    renderSportTypeOptions: function(sportValueArray) {
        const sportTypeOptions = []
        const sportValues = sportValueArray.split(',')
        for (let i = 1; i < 12; i++) {
            for (let j = 0; j < sportValues.length; j++) {
                let label = referee.localeProp('sport-type-' + i)
                if (sportValues[j] === label) {
                    sportTypeOptions.push({
                        value: i.toString(),
                        label: label
                    })
                }
            }
        }
        console.log('sportTypeOptions', sportTypeOptions)
        return sportTypeOptions
    },
    renderRoleLabel: function() {
        return referee.localeProp('match-referee')
    },
    formatRefereeLevel: function(grade) {
        return referee.localeProp('referee-grade-options-' + grade)
    },
    renderGradeIndex: function(refereeSportType, refereeLevel) {
        const sportType = this.renderSportType(refereeSportType)
        const gradeOptions = this.gradeOptions(sportType)
        for (let i = 0; i < gradeOptions.length; i++) {
            let gradeOption = gradeOptions[i]
            if (gradeOption.label == refereeLevel) {
                return i
            }
        }
        return 0
    },
    renderGrade: function(refereeSportType, refereeLevel) {
        const sportType = this.renderSportType(refereeSportType)
        const gradeOptions = this.gradeOptions(sportType)
        for (let i = 0; i < gradeOptions.length; i++) {
            let gradeOption = gradeOptions[i]
            if (gradeOption.label == refereeLevel) {
                return gradeOption.value
            }
        }
    },
    formatAvatar: function(avatar, avatarUrl) {
        return avatar ? avatar : avatarUrl
    },
    renderFirstLetter: function(nameInitials) {
        return nameInitials ? nameInitials.substr(0, 1) : ''
    },
    gradeOptions: function(sportType) {
        console.log('gradeOptions', sportType)
        const gradeList = []
        let grades = []
        if (sportType == '1') {
            grades = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
        }
        else if (sportType == '2') {
            grades = [0, 13, 14, 15, 16, 17]
        }
        else if (sportType == '3') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '4') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '5') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '6') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '7') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '8') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '9') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '10') {
            grades = [0, 13, 14, 15, 16]
        }
        else if (sportType == '11') {
            grades = [0, 18, 19, 20, 21, 22]
        }
        for (let i = 0; i < grades.length; i++) {
            let grade = grades[i]
            gradeList.push({
                label: referee.localeProp('referee-grade-options-' + grade), 
                value: grade.toString()
            })
        }
        console.log('gradeList', gradeList)
        return gradeList
    },
    localeProp: function(key, params) {
        return referee.localeProp(key, params)
    }
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_Referee, Common);

module.exports = tbs_model_vo_Referee